import {
  Box,
  Button
} from '@mui/material';
import {
  ActivityDetailHeaderSection,
  ChatPane,
  CompanyDetailMultitab,
  EarningsCallSummaryButton,
  RevenueDeepDiveButton,
  StockAnalysisButton
} from 'modules';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const CompanyDetailActivity = () => {
  const params = useParams<{ companyId: string }>();
  const queryTuple = ds.useQuery(params.companyId ?? '');

  return (
    <Suspense fallback={<h3>Loading</h3>}>
      <Box
        display='flex'
        flexDirection='row'
        columnGap='1.5rem'
      >
        <Box
          borderRadius='1rem'
          flex='3 1 0'
          bgcolor='white'
          display='flex'
          flexDirection='column'
          columnGap='1.5rem'
        >
          <ActivityDetailHeaderSection.FC
            breadCrumbs={<></>}
            header={`${queryTuple.data.ticker}-${queryTuple.data.companyName}`}
            actions={(
              <ButtonActions
                companyId={params.companyId ?? ''}
                isFavorite={queryTuple.data.isFavorite}
                filingUrl={queryTuple.data.filingUrl}
                companyWebsite={queryTuple.data.websiteUrl}
              />
            )}
          />

          {params.companyId && (
            <Box sx={{
              maxHeight: 'calc(100vh - 188px)'
            }}
            >
              <CompanyDetailMultitab.FC />
            </Box>
          )}
        </Box>

        <Box height='calc(100vh - 120px)'>
          <ChatPane.FC listedCompanyId={params.companyId} />
        </Box>
      </Box>
    </Suspense>
  );
};



const ButtonActions = (props: {
  filingUrl: string;
  companyWebsite: string;
  isFavorite: boolean;
  companyId: string;
}) => {
  const [
    toggleFavorite,
    toggleFavoriteTuple
  ] = ds.useToggleFavorite(props.companyId);

  return (
    <>
      <StockAnalysisButton.FC
        companyId={props.companyId}
      />

      <RevenueDeepDiveButton.FC
        variant='companyProfile'
        companyId={props.companyId}
      />

      <EarningsCallSummaryButton.FC
        variant='companyProfile'
        companyId={props.companyId}
      />

      <Button
        variant='outlined'
        color='secondary'
        onClick={() => window.open(props.filingUrl, '_blank')}
      >
        Company Filings
      </Button>
      <Button
        variant='outlined'
        color='secondary'
        onClick={() => window.open(props.companyWebsite.includes('www.') ? props.companyWebsite : `https://www.${props.companyWebsite}`, '_blank')}
      >
        Website
      </Button>
      <Button
        variant='outlined'
        color={props.isFavorite ? 'primary' : 'secondary'}
        disabled={toggleFavoriteTuple.loading}
        onClick={() => toggleFavorite(!props.isFavorite)}
      >
        Favorite
      </Button>
    </>
  );
};
